import { addDays, endOfDay, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { getTasksEventsForDateRange } from 'shared/lib/full-calendar';
import { Task } from 'shared/types/task';
import { Timestamp } from 'shared/types/timestamp';
import { getWeekStartsOn } from 'shared/utils/get-week-starts-on';

export type Options = {
  rangeReferenceDate: Timestamp;
  dayRange: number;
  hideCompleted?: boolean;
};

export const useTaskEvents = (
  tasks: Task[],
  { rangeReferenceDate, dayRange, hideCompleted }: Options,
) => {
  const user = useUser();
  const weekStartsOn = getWeekStartsOn(user);

  return useMemo(
    () =>
      getTasksEventsForDateRange(
        tasks.filter(({ archivedAt }) => !archivedAt),
        {
          startDate: startOfDay(rangeReferenceDate),
          endDate: endOfDay(addDays(rangeReferenceDate, dayRange - 1)),
          hideCompleted,
          weekStartsOn,
        },
      ),
    [dayRange, hideCompleted, rangeReferenceDate, tasks, weekStartsOn],
  );
};
